var Component = require("!../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./CabecalhoDaSolicitacao.vue"),
  /* template */
  require("!!../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-2ca4ff70\"}!../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./CabecalhoDaSolicitacao.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/controle-de-solicitacoes/detalhes-da-solicitacao/components/CabecalhoDaSolicitacao.vue
// module id = 1040
// module chunks = 1